import { create } from "zustand";

interface RenderTickStore {
  tick: number;
  bump: () => void;
}

export const useRenderTickStore = create<RenderTickStore>((set) => ({
  tick: 0,
  bump: () => set((s) => ({ tick: s.tick + 1 })),
}));

export const bumpRenderTick = () => useRenderTickStore.getState().bump();
